import { useSelector } from 'react-redux';
import { makeFetchEntityByIdSelector } from '../../../selectors/fetch';
import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';
import { useEffect } from 'react';

const useSetupConfig = () => {
  const { loading, response: values = {} } = useSelector(
    makeFetchEntityByIdSelector('setup')
  );

  const { onFetch } = useFetch('setup', Api.SETUP);

  useEffect(() => {
    onFetch();
  }, []);

  return {
    loading,
    values,
  };
};

export default useSetupConfig;
